import script from "./ModalWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalWindow.vue?vue&type=script&setup=true&lang=ts"

import "./ModalWindow.vue?vue&type=style&index=0&id=2d028056&scoped=true&lang=css"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d028056"]])

export default __exports__